/**
 * Expense line categories — aligned with ReimbursementFormNew and Mongo schema.
 * Form may send Material_Purchase; DB stores materialPurchase.
 */
export const EXPENSE_CATEGORIES = [
  { key: "lodging", label: "Lodging", formKeys: ["lodging"] },
  { key: "boarding", label: "Boarding", formKeys: ["boarding"] },
  { key: "food", label: "Food", formKeys: ["food"] },
  { key: "conveyance", label: "Conveyance", formKeys: ["conveyance"] },
  { key: "materialPurchase", label: "Materials", formKeys: ["materialPurchase", "Material_Purchase"] },
  { key: "PO", label: "Purchase Order", formKeys: ["PO"] },
  { key: "Invoice", label: "Invoice", formKeys: ["Invoice"] },
  { key: "other", label: "Other", formKeys: ["other"] },
];

export function getCategoryAmount(expense, category) {
  if (!expense) return 0;
  for (const k of category.formKeys) {
    const v = expense[k];
    if (v != null && v !== "") return Number(v) || 0;
  }
  return 0;
}

export function sumCategoriesForExpenses(expenses = []) {
  const totals = {};
  let grand = 0;
  for (const cat of EXPENSE_CATEGORIES) {
    const sum = expenses.reduce((s, e) => s + getCategoryAmount(e, cat), 0);
    totals[cat.key] = sum;
    grand += sum;
  }
  return { totals, grand };
}

export function lineTotal(expense) {
  const stored = Number(expense?.total);
  if (stored > 0) return stored;
  return EXPENSE_CATEGORIES.reduce((s, c) => s + getCategoryAmount(expense, c), 0);
}
